import { where } from "firebase/firestore";
import _ from 'lodash';
import { createRefPath_event } from "../../../global/firestoreData/appData/appRefPaths";
import { golfEnums } from "../enums/golfEnums";
import { _matchPlayPercs } from "../golfCalcs/calcMatchStatus";
import { geGCGHandicapIndex } from "../golfCalcs/courseHandicap";
import { createMatchScorecardsWithResults } from "../golfCalcs/createMatchScorecards";

const _useUsgaPercHcp = true

// recharts
// https://www.usga.org/content/usga/home-page/handicapping/roh/Content/rules/Appendix%20C%20Handicap%20Allowances.htm

export const createGolfRoundMatches = async (database_fns, paps_state, golfRoundKey, matches, handleDone) => {

  const { pathViews } = paps_state

  let _refPath = createRefPath_event(pathViews, ['golfTournaments', pathViews.golfTournaments, 'golfMatches'])
  const _where = [where('tournamentRounds', '==', golfRoundKey)]

  // get the existing matches
  database_fns.get_data({ refPath: _refPath, wheres: _where }).then(existingMatches => {
    if (existingMatches && Object.keys(existingMatches).length > 0) {
      deleteExistingGolfMatchPromise(database_fns, _refPath, existingMatches).then(dRes => {
        matchesAddPromise(database_fns, _refPath, matches).then(rss => {
          // console.log('rss', rss)
          handleDone()
        })
      })
    } else {
      matchesAddPromise(_refPath, matches).then(rss => {
        // console.log('rss', rss)
        handleDone()
      })
    }
  })

}

export const updateGolfRoundMatches = async (database_fns, paps_state, matches, handleDone) => {

  const { pathViews } = paps_state

  let _refPath = createRefPath_event(pathViews,
    ['golfTournaments',
      pathViews.golfTournaments,
      'golfMatches'
    ])

  matchesUpdatePromise(database_fns, _refPath, matches).then(rss => {
    handleDone()
  })
}

export const createGolfRoundMatchesPreview = (golfTournament_state, golfRoundKey, addResults, callback) => {

  const { details, tournamentGolfCourses } = golfTournament_state
  const { golfers: golfers_tournament, lineups, rounds, teams } = details

  const roundData = rounds && rounds[golfRoundKey] ? rounds[golfRoundKey] : null

  const wins = {}

  if (roundData) {

    const { numberOfMatches, lineups: roundLineups, golfersPerTeam, golfCourse: golfCourseKey } = roundData ?? {}

    const team1LineupKey = roundLineups ? roundLineups.team1 : null
    const team2LineupKey = roundLineups ? roundLineups.team2 : null

    if (team1LineupKey && team2LineupKey) {
      const lineup_team1 = lineups && lineups.team1 && lineups.team1[team1LineupKey] ? lineups.team1[team1LineupKey] : null
      const lineup_team2 = lineups && lineups.team2 && lineups.team2[team2LineupKey] ? lineups.team2[team2LineupKey] : null

      if (lineup_team1 && lineup_team2) {

        if (golfers_tournament && numberOfMatches && lineup_team1 && lineup_team2) {

          const golfers_team1 = _.orderBy(lineup_team1, 'position')
          const golfers_team2 = _.orderBy(lineup_team2, 'position')

          const golferGroups_team1 = golfers_team1 && golfersPerTeam > 1 ? _.groupBy(golfers_team1, 'groupNumber') : _.groupBy(golfers_team1, 'position')
          const golferGroups_team2 = golfers_team2 && golfersPerTeam > 1 ? _.groupBy(golfers_team2, 'groupNumber') : _.groupBy(golfers_team2, 'position')

          if (golferGroups_team1 && golferGroups_team2 && !golferGroups_team1.undefined && !golferGroups_team2.undefined) {
            const matches = {}

            // loop: create a mathch for each of the match numbers
            for (var matchNumber = 0; matchNumber < numberOfMatches; matchNumber++) {

              const matchGolfers_team1 = golferGroups_team1[matchNumber]
              const matchGolfers_team2 = golferGroups_team2[matchNumber]

              const team1_matchGolfers = updateTeamGolfersMatchInfo(golfers_tournament, matchGolfers_team1, golfCourseKey, tournamentGolfCourses, golfRoundKey)
              const team2_matchGolfers = updateTeamGolfersMatchInfo(golfers_tournament, matchGolfers_team2, golfCourseKey, tournamentGolfCourses, golfRoundKey)

              const tgc = tournamentGolfCourses ? Object.values(tournamentGolfCourses)[0] : {}
              const { holes } = tgc ? tgc : {}

              let hcpCouseLow = 100

              hcpCouseLow = getLowCourseHcp(team1_matchGolfers, hcpCouseLow)
              hcpCouseLow = getLowCourseHcp(team2_matchGolfers, hcpCouseLow)

              const _match = {
                matchNumber: matchNumber + 1,
                round: golfRoundKey,
                team1: team1_matchGolfers,
                team2: team2_matchGolfers,
                lowCourseHandicap: hcpCouseLow
              }

              if (addResults) {
                const x = createMatchScorecardsWithResults(wins, _match, holes, matchNumber, teams)
                const { holeScores } = x ? x : {}
                if (holeScores) {
                  _match.holeScores = holeScores
                }
              }

              matches[matchNumber] = _match
            }

            callback && callback({ previewSuccess: true, matches_round: matches, roundMatches: matches })
            return matches
          }
        }
      }
    }
  }

  return false

}

const getLowCourseHcp = (tg, hcpCouseLow) => {
  Object.keys(tg).forEach(key => {
    const g = tg[key]
    const { courseHandicap, matchHandicap } = g
    if (parseInt(matchHandicap) < hcpCouseLow) {
      hcpCouseLow = parseInt(matchHandicap)
    }
  })
  return hcpCouseLow
}

export const getMatchHandicap = (courseHandicap, courseHandicapIndex, golfRoundKey, _fullGolfer) => {

  let _matchHandicap;
  let _matchHandicap_l;

  const { firstName, lastName, tournamentHandicapIndex, courseHandicap: _courseHandicap, courseHandicapIndex: _courseHandicapIndex } = _fullGolfer ?? {}

  // const xxx = {
  //   golfer: firstName + ' ' + lastName,
  //   tournamentHandicapIndex,
  //   _courseHandicap,
  //   _courseHandicapIndex,
  //   courseHandicapIndex,
  //   courseHandicap,
  // }

  // console.log('xxx', xxx)

  switch (golfRoundKey) {
    case golfEnums.roundTypes.singles:
      _matchHandicap = courseHandicap ? Math.round(courseHandicap * _matchPlayPercs.singles) : '-'
      break;
    case golfEnums.roundTypes.bestBall:
    case golfEnums.roundTypes.bestBall1:
    case golfEnums.roundTypes.bestBall2:
      _matchHandicap = courseHandicap ? Math.round(courseHandicap * _matchPlayPercs.bestBall) : '-'
      _matchHandicap_l = courseHandicapIndex ? Math.round(courseHandicapIndex * _matchPlayPercs.bestBall) : '-'
      if (_useUsgaPercHcp && courseHandicapIndex) {
        _matchHandicap = _matchHandicap_l
      }
      // if (_matchHandicap !== _matchHandicap_l) {
      //   console.log('Diffs', firstName, lastName, _matchHandicap, _matchHandicap_l)
      //   _matchHandicap = _matchHandicap_l
      // }
      break;
    case golfEnums.roundTypes.alternateShot:
    case golfEnums.roundTypes.alternateShot1:
    case golfEnums.roundTypes.alternateShot2:
      // this will be figured out after
      _matchHandicap = courseHandicap
      break;
    default:
      _matchHandicap = courseHandicap ? courseHandicap : '-'
  }

  return _matchHandicap

}

/**
 * 
 * @param {object} golfers_tournament 
 * @param {object} golfers_match_team 
 * @param {string} golfCourseKey 
 * @param {object} tournamentGolfCourses 
 * @param {string} golfRoundKey 
 * @returns 
 */
const updateTeamGolfersMatchInfo = (golfers_tournament, golfers_match_team, golfCourseKey, tournamentGolfCourses, golfRoundKey) => {

  const gfs = {}

  // loog through the match golfers for the team
  _.forEach(golfers_match_team, (golfer, golfer_key) => {

    const { golferKey } = golfer

    let fullGolfer = golfers_tournament[golferKey]

    const _fullGolfer = _.cloneDeep(fullGolfer)

    // removeFromObject(_fullGolfer, ['auth_uid', '_authData', '_dataProps', '_updateDate', '_itemKey', 'email'])

    const { courseHandicap: _courseHandicap, courseHandicapIndex: _courseHandicapIndex } = geGCGHandicapIndex(false, _fullGolfer, golfCourseKey, tournamentGolfCourses, null, null, golfRoundKey)

    if (_fullGolfer) {

      gfs[golferKey] = _fullGolfer
      gfs[golferKey].courseHandicap = _courseHandicap ? _courseHandicap : '-'
      gfs[golferKey].position = golfer.position

      gfs[golferKey].matchHandicap = getMatchHandicap(_courseHandicap, _courseHandicapIndex, golfRoundKey, _fullGolfer)

      delete gfs[golferKey].teams
      delete gfs[golferKey].team
      delete gfs[golferKey].id
    }
  })
  return gfs
}

const deleteExistingGolfMatchPromise = (database_fns, paths, existingMatches) => {
  const promises = []
  Object.keys(existingMatches).forEach(mKey => {
    const pr = database_fns.doc_delete(paths + '/' + mKey)
    promises.push(pr)
    // const dRef = roundRef.collection('golfMatches').doc(mKey)
    // promises.push(dRef.delete())
  })
  return Promise.all(promises)
}

const matchesAddPromise = (database_fns, paths, matches) => {
  const promises = []
  Object.keys(matches).forEach(key => {
    const pr = database_fns.doc_add(paths + '/' + matches[key])
    promises.push(pr)
    // promises.push(golfMatchRef.add(matches[key]))
  })
  return Promise.all(promises)
}

const matchesUpdatePromise = (database_fns, paths, matches) => {
  const promises = []
  if (_.isArray(matches)) {
    matches.forEach(match => {
      const pr = database_fns.doc_update(paths + '/' + match.id, match)
      promises.push(pr)
    })
  } else {
    Object.keys(matches).forEach(key => {
      const pr = database_fns.doc_update(paths + '/' + key, matches[key])
      promises.push(pr)
    })
  }

  return Promise.all(promises)
}


// export const createGolfMatches = (eventTeams, roundLineups, totalMatches) => {

//   console.log('roundLineups', roundLineups)

//   const matches = {}

//   if (totalMatches && roundLineups && eventTeams) {
//     // loop total matches
//     for (var matchNumber = 1; matchNumber <= totalMatches; matchNumber++) {

//       const match = {
//         matchNumber: matchNumber,
//         team1: null,
//         team2: null,
//       }

//       let hcpLow = 100

//       // loop lineups
//       Object.keys(roundLineups).forEach((teamKey, teamIndex) => {
//         const teamLineup = roundLineups[teamKey]

//         const golfers = createMatchTeamGolfers(match, teamLineup)

//         golfers.forEach(golfer => {
//           if (golfer.courseHandicap < hcpLow) {
//             hcpLow = golfer.courseHandicap
//           }
//         })

//         if (teamIndex === 0) {
//           match.team1 = matchTeam(eventTeams, teamKey)
//           match.team1.golfers = golfers
//         } else {
//           match.team2 = matchTeam(eventTeams, teamKey)
//           match.team2.golfers = golfers
//         }
//       })
//       match.lowCourseHandicap = hcpLow
//       matches['match' + matchNumber] = match
//     }
//   }
//   return matches
// }

// const matchTeam = (eventTeams, teamKey) => {
//   return {
//     teamKey: eventTeams[teamKey].itemKey,
//     name: eventTeams[teamKey].name,
//     color: eventTeams[teamKey].color,
//     leadsBy: 0,
//     holesWon: 0,
//     holesLost: 0,
//     holesHalved: 0
//   }
// }


// const tournamentLineupsGetPromise = (tournamentRoundRef, team1Lineup, team2Lineup) => {
//   const promises = []
//   let ref1 = tournamentRoundRef.collection('tournamentLineups').doc(team1Lineup)
//   let ref2 = tournamentRoundRef.collection('tournamentLineups').doc(team2Lineup)
//   let ref3 = tournamentRoundRef.collection('tournamentGolfers')
//   promises.push(ref1.get())
//   promises.push(ref2.get())
//   promises.push(ref3.get())
//   return Promise.all(promises)
// }


// Matt Swan 5 6
// Jon Thompson 22 21
// Brian Anderson 14 13
// Jordan Varee 15 16
// Jeff Thompson 6 7